export * from '@wix/crm_app-extensions/dashboard';